// Packages
import axios from "axios"

import queryString from "query-string"

import { getStoreInstance } from "../../../store"

// Actions
import { setStystemError } from "components/Stacker/actions/ApplicationActions" // eslint-disable-line import/first
import { getIsMensExperience } from "components/Stacker/components/Common/helpers"
import { getDY_SR } from "stackerConfig"

export default class ApiUtils {
  // HTTP Methods
  static METHOD_GET = "GET"

  static METHOD_POST = "POST"

  static METHOD_PUT = "PUT"

  static METHOD_DELETE = "DELETE"

  // Response Status
  static RESPONSE_SUCCESS = "success"

  static RESPONSE_FAIL = "fail"

  static RESPONSE_ERROR = "error"

  static RESPONSE_REVIEW = "review"

  // static handleUnAuthorizedUser() {
  //   // sessionStorage.removeItem('jwt');
  //   //getDY_SR().functions.dispatch(push("/user/login.html"));
  // useNavigate()('/user/login.html')
  // }

  static handleErrors(resp) {
    switch (resp.status) {
      case 401:
        //this.handleUnAuthorizedUser();
        break

      case 400:
      case 404:
      case 500:
      case 504:
        console.log("Got a 504 response, setting SYSTEM_ERROR")
        getDY_SR().functions.dispatch(setStystemError())
        throw new Error("Error occured")

      default:
        break
    }
  }

  /**
   * Common utility function to send ajax requests
   *
   * @method     makeAjaxRequest
   * @param      {object}    options
   * @param      {Function}  onSuccess
   * @param      {Function}  onFail
   */

  static async makeAjaxRequest(options, onSuccess, onFail) {
    const isMenStacker = getIsMensExperience()
    if (!options.isAbsoluteUrl) {
      // API URL only for current Site [i.e. NOT absolute full URL for Third Part Services]
      if (options.url.charAt(0) !== "/") {
        // https://webmasters.stackexchange.com/questions/56840/what-is-the-purpose-of-leading-slash-in-html-urls
        options.url = `/${options.url}`
      }

      const baseApiUrl =
        process.env.REACT_APP_PRODUCT_DATA_FEED ||
        getDY_SR().config.global.baseAPIURL

      if (
        baseApiUrl &&
        !options.url.includes(baseApiUrl) &&
        !options.isRootUrl
      ) {
        // Don't append base URL for Token API calls [isRootUrl : true]
        options.url = `${baseApiUrl}${options.url}`
      }
    }

    // if (API_BASE_URL) {
    // 	console.log('API_BASE_URL - TRUE : ', API_BASE_URL);
    // 	options.url = `${API_BASE_URL}${options.url}`;
    // }

    if (options.queryParams) {
      if (
        isMenStacker &&
        options.queryParams.q === "builder/bracelet-builder"
      ) {
        options.queryParams.q = "builder/mens-bracelet-builder"
      }

      const queryParamsString = queryString.stringify(options.queryParams, {
        encode: true,
      })
      // console.log('queryParamsString: ', queryParamsString);
      options.url = `${options.url}?${queryParamsString}`
    }

    const isProductUrl = [
      "api.plp.getProductsList",
      "api.product.detail.render",
    ].some((u) => {
      return `${options.url}`.includes(u)
    })

    if (isMenStacker && !`${options.url}`.includes("Male") && isProductUrl) {
      const mensFQParam = encodeURIComponent('gender:"Male"')
      options.url = `${options.url}&fq=${mensFQParam}`
    }

    const {
      application: { baseStore, csrfToken },
    } = getStoreInstance().getState()

    const mimeType = options.type === "html" ? " text/html" : "application/json"
    // const request = new Request(options.url, {
    // 	method: options.method || 'GET',
    // 	credentials: 'include', // Send back JSESSION-ID to server
    // 	headers: new Headers({
    // 		Accept: mimeType,
    // 		'Content-Type': mimeType,
    // 		'Base-Store': baseStore,
    // 		'CSRF-Token': csrfToken
    // 	}),
    // 	body: JSON.stringify(options.payload)
    // });

    try {
      let parsedResponse = {}
      // const resp = await fetch(request);
      //TODO: The AJAX code in this app can likely be simplified, as it no longer has to accomodate the same
      //			responsibilities it once did.
      const resp = await axios.get(options.url)
      this.handleErrors(resp)
      if (resp.status === 200) {
        // if (options.type === "html") {
        //   parsedResponse = await resp.text();
        // } else {
        //   parsedResponse = await resp.json();
        // }
        parsedResponse = resp.data
      }

      if (typeof onSuccess === "function") {
        const modifiedResponse = onSuccess(parsedResponse)

        if (typeof modifiedResponse !== "undefined") {
          // If callback fn modifies and RETURN some res,
          // then pass the new res to next .then()
          parsedResponse = modifiedResponse
        }
      }

      return parsedResponse
    } catch (err) {
      if (typeof onFail === "function") {
        onFail(err)
      }
      return err
    }
  }
}
